import React, { useRef, useEffect, useState } from "react";
import * as Cesium from "cesium";
import MissionModelingService from "../MissionModelingService";

const MissionOrbit = ({
  polygonCoordinate,
  selectedCompo,
  selectedCompoId,
  props
}) => {

  const [viewerMM, setViwerMM] = useState(null);
  const selectedGSImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABROSURBVHgB7ZxrjF3VdcfPuXf8nJfH2NjgB+aZ1k6EFFoTA20J0CQNbYJRjaUqTZWU8gECquNUqHyIBz4YRQm2Slu3QpA06UvMEKrUNFCUAEIeg6xQq6U2MSZg7DHYHuPxjF947Lkn67e9/8frnrkzc2dsKyjyko72ufs89t7/vd57n5sk5+k8nafz9KujNDnHlGVZakRZVV1s299T4/78mXgtiyXvCOfnikrJWSQ6HDud6re//uCDD6ZxMCnnHKpPTg0+/G5vb8+vpadHX1Un4HXu2/0okgck77DrdEnnNviSK0vLli0rc/hzDq7rHp37dxTek+q647yzAtYZv0RsbrMbuNE6mnnxYJbhCP1etWoV9zKgxIDI6xctWpRu2bIlf7CnpyedOXNmZvWZ1aednZ0Zz0D8js9k9r4KbfNeMRvtw1jqn87HQw3J+CkfXGRzdVB6IdQJHA3qjjvuCOWNN96Y2gCTl156KX8hoPgG+G3XQ52ByTuGdiJN4aYgptZcJYmi6CfpTEAaFwcVdUv+MiM6qxmHQ8QBXBcAV111Vfraa6/VfPdll12Wbt26NZk8eXIY0DXXXBPq33zzzXyAcJZ/hjb8b3GxV97OAIwJqDEDFBtOi1aGWRMQIgAxTgnn7733XrgmYD788MN04cKFCWBAx48fTydNmpTNnz8/f8fOnTvzRhA/gdXc3BzqjbuYhFBXBAkCKN/vZBwWb8wARQVZNUOIkdMLaez8EE6BOzZv3pxeeeWVyfbt20Pd3LlzR+xDd3d3GBngqU7cBQFWkaNiP0Kd03lZUQ0kddBYAMrvBRyZXMg4AZEK5xKjQ4cOhRJOoYRDAObYsWP5c9RRzpgxIzUOC3UXX3xxKPfv3181AA8QoPF7NKAACZF3flM+hCSqzmQUqssP8uazKNterAAHrgEcuAVwAME6XoJTmpqaSnatZIMJ5ZEjR8Lx7rvvptSp3l/z13kXB+/inX19faULL7ywRFu0+fbbb1eNh75JgcPl9Dv6YnVzUMMowFBUcU7RbDNL69atCx2jk4gUwBw+fJhB5NwzMDDAIJILLrggDMYGnJw4cSJ/jziroaEhO3nyZCo9A3GvPZPZOyq+f3YfopoZZzIZcHICSDyL7kNvAZA7UkQuOe1/jgrSiAB5ZSwW5ZCpjgBViRSziijNmjUr3bFjB4MrTZw4MVyLHJG0tLSkBw4cYIChfnBwMJTTpk1LDh48GEqOXbt2ZW1tbQEc7gUEq08nTJiQ2fPZRRddFMy6gZvZJKDww+BR5ihwXAm4OgKVaRyn5jrLh5iMFyBxDGV0/6uuAw7KGHCka2B/GyRHAtdYVck6GcCYN29e4DS4xQaZlkqlKh3IIKdMmRLKvXv3JgYsZVYulzMA4x12hAFNnz4dkS6bHhJXZbKEXV1dqdUnUa95S5ij4yZ8RJBKI4Ej8jpH3iy0fv36VGIFoRekeOEWA61kAy6hezhM8aY22LLdUzLwqg4TrbI/t2fLcJaBVObgGd5lwJYpDeRS5Kqguyhpn4P2mTBvQQFHSjs6klk0NCNy0EhWLPV8mJyKd9TQEM4ROHANHaYOHUPHGagBxLWSxGnq1KmpiWNqgw2/K5VKVV+Mu0LbcA8iZM/DWRX00dGjR7FiFfQV4kfZ2NhYgXuwfpTGXYGzsHTSSdb/CmOIeiiffB+a1AWQSyPk0bVmgdL0QgnPljDgiiuuKMmXMb1A0Bn0DrPLTFMCCod1vBS5IugigWKDSG3QofQAGbiZAQk3ZPwGLA4AsndUODdjkIMFSB988AHXAkAAheIWWHIDvPl3QNUEqKYO8j6D9JACS7gH2bZGS8RS5vmiWAPnmF4I96Bjor7IuQZwuAdQiJ9sQOH8hj9oavm9pZOXTGhqnTdxQtrC8wMn0v4De09u6d42Yde/rj3QbQPPBJg9FwZu4GDyK/buCuJnj1UQa7jFuKoSJ42wpQLwKG6bVJR3UOzeyx6JRuKgnBR9G5vm5lyiZRapjKOH74JIYaHef//9oC8AR1wDGAZYic7+1o0NrTfcNuXOg/sHlv3fK4fm/v+mw8m+9waSI/2Dob3GlnJy6W9MCcfcy6dsvfbmac+9+uKxp3607vAuTD0gWTtYsorppIo4y+ikiRhOJfWIVsX6kRGySNS8M2nObcX5dWMWsSqfR7oHxQw4xExwioDxYsWMCpioeMsBmM8aMJ+f8hcbn+v96vMd+1sEyGh04ZyJyaeXTk8+sbils6c7WfODb/fsAiQOgIGTEDlrZxBRk7i1trZW4L4NGzZknHv/SOkTr4+SGrHasADBNYpjACemHhCxwEVSygCD6GBVpHPsvAzHYI3gGnTOirVtS157+cCaZ/6lZ269wNQC6g+/PLP7qk+0rPyblQc3ApC9fxCQKK3dABgcZLoJ0QK4XGmLi2L/A0inh1w7mK1l5qWYcyWtF5kc419kMqUAwyFgOIzF4ahgqgGG46F/m3nnyz/u6Xhy3Z5xgwPt2z2QfPfh3XO7ntv/5OqOGSsBnwNOpU0sJef0A4dSnrrCHYUkep88bOcMD2GYIQB5za4X+MwfnjLBIo0SNlCHVwxIdI4S0w0wdH5154yv//uj3aue+UFPcrZovb3rn9fs/kuAZyLgVtpDrAHJuCSN4UqI5dCRPEdqBd+IeLHWe7OhCwW1OUiRehEcKWYap9E9e/YEX0fgyGLRYWKx+0ysfvjYnhUv/MeB5GwT7/zP772/CtEVSGpf3CwXQ5kC9CbjwUVBn8rpzVcSapj6ulc1xJqYT4uBQlQtjlFH6CSzCOcs//qM+dv/t2/N2eScIsFJ6LVP3TJ5Gm0jZjIOcBH3mGiFSZSHb8FsBgehTzs6OnJGGI5qsVoeoHoFLdMu5Rx9jjycQDHTOUIJrNY9325e8+j9O5ahN8ZDwXLdNj2cb3qhL3nnjWM172tsLift/3Tl2tV37n3ExGwQs49Vsz4FpY1Fs3Kwv79/cMGCBYlX1lLULpE2hINqOooSsWIK1YcTOIWYeWaKOs2gtVW6/d7mua+/2j9ucERHDp1S6Itvag0+Uq33cc/GH/f++e9+vuXx/3m5clDBrEIakenL4EwiZuYXJT6dogWGpEZ0X0tJh7LgHwRS+hOWJUKHEC/iKsVU0Cd/Z9LyF89Q71x7c2uy+OZTwLzz82PhfDjCp8LxJFzRRHkxK4LlM5HQSCJWUwfJ/+FcWUIpaBFmlA6YA4Z+Cp3AGaSDP3uh7zP1co8Xpfy3OYW3fnlm8vHFTeH30UMjuwZwEV45bSu+oz8WlwVFjR7C4koP+bF4IwQVLVld62LDLdEoiSWic4jXuz/vXZjUSeiQex+enyz/2uzAKVst7CD02PTTvgDOk3+/J9zDtZGIkOWWpS2tL60/2stvon4DqOoeMzDKmecoxMXHzEX1Vc8M4SBkULGXsoWe0D8ypSTFzJXPLRgsfsllDfN2jDIYT3AK4gggxF57jfMQJ+qkmOGQ0RxMQL3uC41L6AfiDlfLcUQl4JKYigj3wkkYHY1P4GiPgH/vEA5SqoMb41Jw/gAmnoiYNCiEW2/WIX8WEWub1bDonTEAdOlvTkm+9/DuMMAeA+fe1fMDt8A5FlbU/R5Euqm1NI/0CLlqEZlIAyicx6A6cA9KGlN/9913a7wa68hKGvJLOnoZJcibDxR8i1ifJ790b8OErGWs4QTRO4Rfs/L2bUG07v+7S5Opsb4egssmTCg1w8UyGFLO8tO0lETOHA4ibx2Xq5QQzIo6qJaIhVKaXcs4JJ60NiULJiKBpWRXWhrb0u6mn/Qlt/7paU6BE1Yu3ZYcNZBR0nDYeIhJg8M5xxfiXCEHi5amV0NSX2N1ObDqzGaNd4e7pN1tIS8s+RI6sEoBiYNEyD3JLM5PHE8ONY5h5tE9APGVv56T18ENf/vAzgDWI09/LHDUaIQiP3G8cig8b9lKJo1z9CQ5Ks4VcjDRBN7KDfkVj6IfVMuKKUYJmw9i7jmJ2bxwwxtvvJHhlSLPJKTIF/f29mYkqY4eznYxoHf6R9ZDKGL0jcD8I9M3+D4AhoguvuWU34PI1eMywGn7eyph+wfZRzMeYXUk6skwaFZtGQuqQr4QVizGZVldVsylWoeICkqa/IqteQW2VT2zRYdQkD956uCri367KRmNMOsoYnEKBDgQAP8X+shEbbgQYwhAZgG7t324C3BI8gOEREzkdZBI0YJfDPU0bLBqi4M1r2Hmi+vmEJ2hcz97/mTf1Uuau5NRCJHAHaD85p+9FUBaYIMUaGPNAMy5fPLWp//xWLfvj6Vmwrk5ifl9SsEWn1fkUEw31wQBESNf6+tgSUINOAhLBsFFrCooJ6zVh2kzJnbWo4cAhWg/V8yme+rVOZ64/1O/3/Yc+WraN+8+9MeACelXRAzx989gmQlUtQvE7X8c3cyDplgORaZ9OZ41WTnQuZZi6Byd3PDs4OOfWTajP6ljYDoA9LvRH3ro+1eMCSRClU0vDvwQEacPXkGL0D9+rYwSHStrHTOo9UXz2mrLUnPc2sKLA5gy9XincaNBmC2zHJlF+JlZtGzTs4f7v/Fo2xPPd+5fUcsnQhkDAEAMR/hBcNVoxHs+fm3zU+vu79tpbYfVDCia9aCPWMc3xcwmhySucOTPCyCX8qjGolghGfQpD58PIl3AMvK2bdtCxGy/S/v27cPnaIhrX2EV44YvNk2bNPn4f3dYHjo5h/TVB+Z0Nzc1Lnv6H47tNJ2jfNAgqxwk703nVOB2y0dnmzdvDmtqJhX5QqLy7RGgrG6AlIWEDbUpisVCv9xDwgxOwlM11m4AMNKfStp/7ZHW67osWX+usoq4Btd/btbyb92zu4sVDqOTUcwDQKxqwFEA5pejAUg7aPktBT3mlGtU1vmSLbILi2IJUNawrpQfsyVlLV306IreV774lYsevGnp9ORs002md26/a/ZagUMWkXa1JI34mw7KvK7UGPz4oGJo5WlYHeT8ghDECSTEDFcd3YOV4Jo2ERgogFchOGRpGZC++Sc9j6/unNMytbm84mxxEpzzBQP+gWU9j2sB0RQ0IGVaG1N4wf220ht+2yQOeZfbX+3HexqLGu2nfl+Q/CEvZpSIms1QWDQkGWXyH7aokGJgbYw8tZZ+ELf7vtO2ZPsWS+J/v2fueFOxWLpbvzSz++ob2lau+6v+LjiGBUMmAmAsyxDEC9ES55jhGPR7GpWLLohXzXQrNGwsJpCkxLyY6UYaRdQ4h3PiiiZiF9bMtY4exO0bva80Tpl6x33fWtC5/J7ZYzLjAHPbnbP6H3riY2sHjzR+7jv37OninVpVxe8BHCXpeWb27NnkqqrEa7gdsSPtWRx26bmQRKraF8S2F86lsLXBEm6CWywuY3dY2W9egJOUEv2SLQl98tNTl236ae9nd/3i2EI8anJAfvMCABKyXH1dc/e0CyZ2vvrMiSc2Pn+0T6BL36B7JFbRWQ2gab+Q5x78OetbAM1vXBjOxI8EULim/cV+A4M3+dRJ1Di3jpS13c44qqwFRSXRAUuroNzP+R/f3TRvzuUN89pmlReG7S92ZeB41n/0cNK98UeHNm54dqBfW18otWEB/0Y7O+BcdKBES+DQRnGZR2PUck/koDDsugHyIOm330nv90KzDZdzOAmuIbWplCz+kl91JUejzVQ+wU6pTVR4w1D0iPOdZgDjQdHmKQGEiMuqsu3Fg8N5YWdHRZNe2GA+hIY18zE3kp8LdUp9XgCZkxg6AyuzxYQOzpkzJ1gNZtS4JyzgsZBnSfTBuE0liAbXGDgLfugTu/+kDTacc1AfN0wFRWwKt2Ip1CBavJPSuGWQnRyAA+egE8lb0R+SfBDJMbgHcKJyTmM4VTPFURdAzmHMtX30iyiDo8WsINf4RrjxdJQOsg0OcPBDonnNBwRIdi0ccAPARXACeHjDDqCq65SQdA7t0QZtsZlKXCMRY5mZPpqzG4DxXrNjhBEzoOlIF6WsYceYdcs3cnLdb+bkN+KmDeFS2rgALFNTpw0F2n2hdpQ7pizmcPRb4gQoFmMRiIbfl1xySab0i3FXBR/Nm3TqpXsiQFlx7/dIII0KUH6j+3CFsvgJgkAydmZjZ/hcQCBpnw7L1QpNagEEkZqIij+AwwoKVlE7x+S5S99og5SsFde8UuZrIDaY11gpruvLn1Hv8DuBPfKRq5L4TZjfLlPynzgVgQIkLB0rs2rDgwXpcwSftZTjByj+gxfFWDGIzsXKO4PuU4TMj2s08YJG3f6iRLaUWfxoLlWjHR0dFX1KifLGYdPvt956K8RtDADLgm4gcLQk+iDnHAyc3Rf+UB0lB74NwEgJU/f666+jsCuyVBgLgcNOVm31jWDkCjkeWT3ghMlK6qT4wtQpuFwvOW87JKYAypaLkuuvvz7p6upCJ4RPDLT5Aa4iJOBjF3LHIrgMAFieqfU5FM8racfmTAMltM/WOr8X2iXB8ue906tFiaSecSdjI32bmmY1PqjTZ5jUFb8bg/S5pf+qUEqdwQOcStX5LKbPJXv/htI7gVpv10bU0PFRPOZhB5yMg2oo7yrr5sl/qOvBKu4WEcX9O/lg5csArD7L9Ht7ChZKmdC0xucG4/oDgnEBFDviE2s5C0s3iYretwiwGKzfOcL5XXfdlTz22GP5x7yQ/7BX3rCuSdcUxCrzGYl8sOP48nncACUFfSRwkijb+nit1jfynorAwRG+brjvUf07JVJ5x6q3suRaIRkHnclfU2Q+HJGnHS1GzuLeA9eD3qs1jgheuQ7qdB6/q0j8c/7rZixo8Wtn/818Ns5Pwc8l+b+lGPJXFe3x7yPa419OZO6vK1Tnj/bC31i0u7+k0JFV/+XFkIW/jzIV/79jyH96FEFrd//RISD8M+2n/59jyLuTM1MXvxoqzmaRq3yZDANg8VpSzTlJ/F1zl/yvC9UcoEKc7CP+tzfn6TydpzOiXwIMLfNiGezocwAAAABJRU5ErkJggg==";
  const normalGSImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANVSURBVHgBtVfPSxtBFJ6oGBRX07RYIhYLsQkJiKAigpc9KHhoqlhBvCgKNpccBP0D2lNB8JZLerGINgcvkvSkCF6koigoJdBgQNtiUEhMTIkohvZ9yW67jcnubNQPPpKZTOabN+/HvjUwPghEG1EkthMt0hyQIoYl7hI3eDY0MG3BEYkC40OUGCR+Jp6wEoQh9kaHYKEDfJAOcQvlRf40LYkaWenAgUXp8wuP8Fvia3Z/aCE2sDzf5wtP37OoDATmf5YrhV1ED3s4wHJkwFcM5ODCVfhYLk10o7m52TgxMWHG95WVleT29na6yFIIv8JnmTTxslRRGYlEIgP29/ebcJAiy+T0ZLKwi90Bg4ODdX19faZkMpk5ODhIY6yyPFsTICwyTmthidvtfpw/Hh8ff9rW1iY0NTVVwmqNbbJVEMGFKG5hnMILCwsvxsbGnvT29go1NTWGra2tdG1trSEej99MTk5+Pz8/z+zt7V0Sfqts9QsW2xgnPB5PfSAQiK2vryfsdnv18fHx9cDAQB0dJhYKhbIBRQfIgBpbtesSdjgcVUtLSzE6wI/5+fnTubm5511dXQJF8WVjY6OeKmeBsK5abDKZsrk/Ozt7JopiyGKxGCmFrHTd5Tq2Ecp0LGZra2sJCqZ6eXx4eHjd3d0duri4yHR0dAidnZ3VvHtBOMW7GMUB0ev1ep/Jc/Dn6OjoUTQavVpdXXVQAFZybJVC5frENPw8PDxsgj8piv9eJwldI8jI2puenp5HmCPfH6lULSV2IYwHw4jaqp2dHcfy8nKcCsTN1NRUA/m1cnFx8Qy/wbebm5spn88XY/zwV7Dc40pVWBCE8v39/XRra2u1y+X6FgwG7U6ns2poaCjCkTqFsAsfo1fS9HMkErmiSD5VBhRZ6lSpy8WAzmRDDi6/1mqr1WqECGg2mytmZmZ+kgtSZL1Np3i2FZIfi8jlACuQ0wgs8p9VbadwOHxJqRRi2oC1buKJstmDn6fZw+IdkyxWVht0BrCY64FRAuDOj/Igv8yhJ0I3wl2/OYEe+71yolB93WD3a7k/X7SYMADLEQh2VnpDj2zxslxTfwtarzC4dvRjaI14ezI5Pf1MpT5oCSshstwLm43965NlIdyO/MLGVZD+AKRkKk71cyFYAAAAAElFTkSuQmCC";

  const [selectedAOI, setSelectedAOI] = useState("")
  const [selectedGS, setSelectedGS] = useState("")
  const [selectedGSName, setSelectedGSName] = useState("")
  const [selectedSat, setSelectedSat] = useState("")

  const resetPosition = (viewer) => {
    viewer.camera.setView({
      destination: Cesium.Cartesian3.fromDegrees(0, 0, 39000000)
    });
  }

  let imaginary = new Cesium.MapboxStyleImageryProvider({
    styleId: 'dark-v10',
    accessToken: process.env.REACT_APP_MAPBOX_TOKEN
  });

  useEffect(() => {
    const viewer = new Cesium.Viewer("cesiumContainer", {
      requestRenderMode: true,
      shouldAnimate: true,
      animation: false, // Disable the default animation widget
      baseLayerPicker: false, // Disable the default base layer picker
      timeline: false, // Disable the timeline
      geocoder: false, // Disable the geocoder
      homeButton: false, // Disable the home button
      navigationHelpButton: false, // Disable the navigation help button
      sceneModePicker: false, // Disable the scene mode picker
      selectionIndicator: false, // Disable the selection indicator
      fullscreenButton: false,
      imageryProvider: imaginary,
    });


    viewer.scene.globe.baseColor = Cesium.Color.WHITE; // Set a base color for the globe
    viewer.scene.globe.enableLighting = false; // Enable lighting to ensure consistent shading
    viewer.scene.globe.showGroundAtmosphere = false; // Show the atmospheric effects
    viewer.scene.gamma = 2.0; // Adjust the value based on your observation

    resetPosition(viewer);
    setViwerMM(viewer)

    viewer.resolutionScale = 1;
    for (let i = 0; i < viewer.scene.globe.imageryLayers.length; i++) {
      const layer = viewer.scene.globe.imageryLayers.get(i);
      if (layer.imageryProvider === imaginary) {
        // Adjust properties of the imagery layer
        layer.brightness = 0.9; // Experiment with different values
      }
    }
    const toggleTranslation = () => {
      const zoomLevel = viewer.camera.getMagnitude();
      if (viewer.scene.mode === Cesium.SceneMode.SCENE2D && zoomLevel >= 40000000 || zoomLevel === 31890685) {
        resetPosition(viewer)
      }
    }

    toggleTranslation();
    viewer.camera.moveEnd.addEventListener(toggleTranslation);

    viewer.scene.morphTo2D(0);

    return () => {
      viewer.camera.moveEnd.removeEventListener(toggleTranslation);
      viewer.destroy();
    };
  }, []);

  const getGroundStationPackets = () => {

    let gsPacketList = [];
    gsPacketList.push({
      "clock": {
        "multiplier": 1,
        "range": "CLAMPED",
        "step": "SYSTEM_CLOCK_MULTIPLIER"
      },
      "id": "document",
      "name": "Satellite Orbit",
      "version": "1.0"
    })
    props?.gsList?.map((item) => {
      gsPacketList.push(
        {
          "billboard": {
            "horizontalOrigin": "CENTER",
            "image": item?.groundstationId === (selectedCompo === "Ground Station" ? selectedCompoId : selectedGS) ? selectedGSImage : normalGSImage,
            "pixelOffset": {
              "cartesian2": [
                0,
                0
              ]
            },
            "scale": 0.75,
            "show": true,
            "verticalOrigin": "CENTER"
          },
          "label": {
            "fillColor": {
              "rgba": [
                255,
                255,
                255,
                255
              ]
            },
            "font": "montserrat",
            "horizontalOrigin": "LEFT",
            "outlineColor": {
              "rgba": [
                0,
                0,
                0,
                255
              ]
            },
            "outlineWidth": 2,
            "pixelOffset": {
              "cartesian2": [
                12,
                0
              ]
            },
            "show": true,
            "style": "FILL_AND_OUTLINE",
            "verticalOrigin": "CENTER",
            "text": item?.groundstationId === (selectedCompo === "Ground Station" ? selectedCompoId : selectedGS) ? selectedCompo === "Ground Station" ? " " + props?.selectedComponentName : " " + selectedGSName : "",
          },
          "name": "G9",
          "position": {
            "cartographicDegrees": [
              item.longitude,
              item.latitude,
              item.height
            ]
          }
        }
      )
    })
    return gsPacketList
  }

  const getAreoOfInterestPacketes = () => {
    let aoiPacketList = [];
    if (props.bottombarComponent === "Coverage Analysis") {
      selectedCompoId = props?.selectedCVAoi;
    }

    props?.aoiList?.map((item) => {
      let cartographicDegree = []
      item?.coordinates?.map((coor) => {
        cartographicDegree.push(coor[0])
        cartographicDegree.push(coor[1])
        cartographicDegree.push(0)
      })

      aoiPacketList.push({
        "polygon": {

          "positions": {
            "cartographicDegrees": cartographicDegree,
          },
          "extrudedHeight": 0,
          "height": 0,

          "material": {
            "solidColor": {
              "color": {
                "rgba": item?.aoiId === (selectedCompo === "Area of Interest" || props.bottombarComponent === "Coverage Analysis" ? selectedCompoId : selectedAOI) ?
                  [204, 245, 78, 60] :
                  [255, 255, 255, 10]
              }
            }
          },
          "arcType": "RHUMB",  // Set the arcType at the top level
        }
      });

    })

    return aoiPacketList;

  }

  const getSatellitePacketes = () => {
    let satPackete = [];


    if (props.bottombarComponent === "Coverage Analysis") {
      props.setSideReportBarProps({ isSideReportBarVisible: true });

      satPackete.push({
        "clock": {
          "currentTime": props?.coverageAnalysisSatList?.[0]?.['availability']?.split('/')[0],
          "interval": props?.coverageAnalysisSatList?.[0]?.['availability'],
          "multiplier": 3,
          "range": "CLAMPED",
          "step": "SYSTEM_CLOCK_MULTIPLIER"
        },
        "id": "document",
        "name": "Satellite Orbit",
        "version": "1.0"
      })
      satPackete.push(
        {
          "description": "Satellite MetaData Packete",
          "id": "fe04c5b3-3ea1-4666-a103-c44a6d118021",
          "name": "Satellite"
        })
      props?.coverageAnalysisSatList?.map((item) => {
        satPackete.push({
          "availability": item?.availability,
          "billboard": {
            "eyeOffset": {
              "cartesian": [
                0,
                0,
                0
              ]
            },
            "horizontalOrigin": "CENTER",
            "image": "data:image/png;base64,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",
            "pixelOffset": {
              "cartesian2": [
                0,
                0
              ]
            },
            "scale": 0.75,
            "show": true,
            "verticalOrigin": "CENTER"
          },
          "description": "",
          "id": "Satellite/" + item?.satName,
          "label": {
            "fillColor": {
              "rgba": [
                255,
                255,
                255,
                255
              ]
            },
            "font": "montserrat",
            "horizontalOrigin": "LEFT",
            "outlineColor": {
              "rgba": [
                0,
                0,
                0,
                255
              ]
            },
            "outlineWidth": 2,
            "pixelOffset": {
              "cartesian2": [
                12,
                0
              ]
            },
            "show": true,
            "style": "FILL_AND_OUTLINE",
            "text": item?.satName,
            "verticalOrigin": "CENTER"
          },
          "name": item?.satName,
          "path": {
            "leadTime": [
              {
                "number": 5000
              }
            ],
            "material": {
              "solidColor": {
                "color": {
                  "rgba": [
                    0,
                    155,
                    0,
                    155
                  ]
                }
              }
            },
            "resolution": 120,
            "show": [
              {
                "boolean": true,
                "interval": item?.availability
              }
            ],
            "trailTime": [
              {
                "number": 300
              }
            ],
            "width": 1
          },
          "position": {
            "cartographicDegrees": item?.orbitPoints,
            "epoch": item?.availability.split('/')[0]
          }
        })
      })
    } else {
      props?.satelliteList?.map((item) => {
        let compoId;
        if (selectedCompo === "Satellite") {
          compoId = selectedCompoId
        } else {
          compoId = selectedSat
        }

        if (item?.satId === compoId) {
          console.log("Component Id => ", compoId)
          satPackete.push({
            "clock": {
              "currentTime": item?.availability.split('/')[0],
              "interval": item?.availability,
              "multiplier": 3,
              "range": "CLAMPED",
              "step": "SYSTEM_CLOCK_MULTIPLIER"
            },
            "id": "document",
            "name": "Satellite Orbit",
            "version": "1.0"
          })
          satPackete.push(
            {
              "description": "Satellite MetaData Packete",
              "id": "fe04c5b3-3ea1-4666-a103-c44a6d118021",
              "name": "Satellite"
            })
          satPackete.push({
            "availability": item?.availability,
            "billboard": {
              "eyeOffset": {
                "cartesian": [
                  0,
                  0,
                  0
                ]
              },
              "horizontalOrigin": "CENTER",
              "image": "data:image/png;base64,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",
              "pixelOffset": {
                "cartesian2": [
                  0,
                  0
                ]
              },
              "scale": 0.75,
              "show": true,
              "verticalOrigin": "CENTER"
            },
            "description": "",
            "id": "Satellite/" + item?.satName,
            "label": {
              "fillColor": {
                "rgba": [
                  255,
                  255,
                  255,
                  255
                ]
              },
              "font": "montserrat",
              "horizontalOrigin": "LEFT",
              "outlineColor": {
                "rgba": [
                  0,
                  0,
                  0,
                  255
                ]
              },
              "outlineWidth": 2,
              "pixelOffset": {
                "cartesian2": [
                  12,
                  0
                ]
              },
              "show": true,
              "style": "FILL_AND_OUTLINE",
              "text": item?.satName,
              "verticalOrigin": "CENTER"
            },
            "name": item?.satName,
            "path": {
              "leadTime": [
                {
                  "number": 5000
                }
              ],
              "material": {
                "solidColor": {
                  "color": {
                    "rgba": [
                      0,
                      155,
                      0,
                      155
                    ]
                  }
                }
              },
              "resolution": 120,
              "show": [
                {
                  "boolean": true,
                  "interval": item?.availability
                }
              ],
              "trailTime": [
                {
                  "number": 300
                }
              ],
              "width": 1
            },
            "position": {
              "cartographicDegrees": item?.orbitPoints,
              "epoch": item?.availability.split('/')[0]
            }
          })
        }
      })
    }
    console.log("Hello  => ", satPackete, props)
    return satPackete;
  }


  //   function flipLatLong(arr) {
  //     let result = [];
  //     for (let i = 0; i < arr.length; i += 4) {
  //         result.push(arr[i], arr[i + 2], arr[i + 1], arr[i + 3]);
  //     }
  //     return result;
  // }


  useEffect(() => {

    console.log("Hello Componant Update")

    if (viewerMM) {
      if (selectedCompo === "Area of Interest") {
        // setSelectedAOI(selectedCompoId)
      }
      else if (selectedCompo === "Ground Station") {
        // setSelectedGS(selectedCompoId)
        // setSelectedGSName(props?.selectedComponentName)
      } else if (selectedCompo === "Satellite") {
        setSelectedSat(selectedCompoId)
      }

      if ((viewerMM?.dataSources?.length > 0)) {
        viewerMM.dataSources.removeAll();
      }

      viewerMM?.dataSources?.add(Cesium.CzmlDataSource.load(
        [...getGroundStationPackets(), ...getAreoOfInterestPacketes()]
      ));

      viewerMM?.dataSources?.add(Cesium.CzmlDataSource.load(
        getSatellitePacketes()
      ));
    }
  }, [selectedCompo, selectedCompoId, props.gsList, props.aoiList, props.isCoverageAnalysisUpdate, props?.selectedCVAoi, viewerMM])

  return (
    <>
      <div id="cesiumContainer" className="position-absolute h-100 w-100" />
    </>
  );
};

export default MissionOrbit;
